import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { TreeItem } from "@mui/x-tree-view";

const useStyles = makeStyles(() => ({
  root: {
    ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label": {
      backgroundColor: "red !important",
    },
  },
}));

export default function CleanTreeItem(props) {
  const classes = useStyles();

  return <TreeItem className={classes.root} {...props} />;
}
